import { AuthUserType, IUserDTO, UserRole, type IUser } from '@/models/user'

export function buildUserDto(
  formData: {
    id?: string | number
    name: string
    email: string
    description?: string
    password?: string
    receiveEmails?: boolean
    userRole?: UserRole
  },
  existingUser: Partial<IUser>,
): IUserDTO {
  const dto = new IUserDTO(
    formData.description ?? '',
    formData.name,
    formData.email,
    formData.password || '',
    existingUser.clientType ?? 0,
    formData.userRole ?? existingUser.userRole ?? UserRole.User,
    existingUser.blocked ?? false,
    new Date(),
    formData.receiveEmails ?? false,
    existingUser.userType ?? AuthUserType.Normal,
  )
  const rawId = formData.id ?? existingUser.id
  dto.id = rawId !== undefined ? String(rawId) : undefined
  return dto
}
